<template>
  <entity-edit-dialog
      @submit="submit"
      @close="close"
      v-model="visible"
      ref="editDialog"
      :dialog-title="dialogTitle"
      :submitting="submitting"
      :max-width="700">
    <template v-slot:contentCard>
      <v-card-text class="pt-5">

        <entity-dialog-input-row :label="$t('corporation.name')" :required="true">
          <v-text-field v-model="corporation.name"
                        outlined
                        hide-details="auto"
                        style="max-width: 20em"
                        autocomplete="false"
                        :rules="[buildMaxLengthValidator(256), buildRequiredValidator(),]"/>
        </entity-dialog-input-row>

        <entity-dialog-input-row>
          <v-checkbox :label="$t('corporation.allowCsvExport')"
                      v-model="corporation.allowCsvExport"/>
        </entity-dialog-input-row>
      </v-card-text>
    </template>
  </entity-edit-dialog>
</template>

<script>
import EntityDialogInputRow from '@/components/entity-crud/EntyDialogInputRow';
import i18n from '@/i18n';
import EntityEditDialog from '@/components/entity-crud/EntityEditDialog';
import { buildRequiredValidator, buildMaxLengthValidator } from '@/utils/ValidatorBuilders';
import CorporationsService from '@/services/CorporationsService';

export default {
  name: 'CorporationDialog',
  components: {
    EntityEditDialog,
    EntityDialogInputRow,
  },
  data: () => ({
    corporation: null,
    visible: false,
    submitting: false,
  }),
  props: {},
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },

    dialogTitle() {
      if (this.corporation?.id) {
        return i18n.t('corporation.editDialog.titleEdit');
      } else {
        return i18n.t('corporation.editDialog.titleAdd');
      }
    },
  },
  methods: {
    buildRequiredValidator,
    buildMaxLengthValidator,
    close() {
      this.corporation = null;
      this.visible = false;
      this.submitting = false;
    },

    openCreateNewCorporation() {
      this.corporation = {
        name: null,
        allowCsvExport: null,
      };
      this.visible = true;
    },

    openEditForCorporation(corporationId) {
      CorporationsService.get(corporationId)
          .then(result => {
            this.corporation = result.data;
            this.visible = true;
          }).catch(err => {
        console.log(JSON.stringify(err));
      });
    },


    submit() {
      if (this.submitting) {
        return;
      }

      if (!this.$refs.editDialog.$refs.form.validate()) {
        this.$refs.editDialog.showFormHasValidationErrorsMessage(i18n.t('corporation.requiredInformationMissing'));
        return;
      }

      this.submitting = true;
      CorporationsService.save(this.corporation).then((result) => {
        this.$emit('done', result.data);
        this.close();
      }).catch(err => {
        console.log(JSON.stringify(err));
      }).finally(() => {
        this.submitting = false;
      });
    },
  },
};
</script>

<style scoped>
.repeat-weekdays > * {
  margin-right: 1em;
}
</style>
